<template>
  <b-badge
    class="al-badge"
    :class="{ 'not-clickable': !clickable }"
    :href="href"
    :rel="rel"
    :active="active"
    :pill="pill"
    :variant="variant"
    :style="style"
    test-id="al-badge"
    @click="$emit('click', $event)"
  >
    <slot>this is the slot</slot>
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue';

export default {
  components: {
    BBadge
  },
  props: {
    href: {
      type: String,
      default: null
    },
    rel: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    style() {
      const res = {};
      if (this.background !== '') {
        res.background = this.bgcolor;
      }
      return res;
    }
  }
};
</script>

<style lang="scss">
/**
 * Variables
 */
$font-color: #36403f;
$font-color-hover: #96b9b9;
$font-color-active: #97e2e0;
$font-size: 12px;
$pd-body: 4px 8px;
$br-radius: 2px;
$bg-content: #ebf1f1;
$bg-content-hover: #effaf9;
$bg-content-active: #ecfaf9;
$m-content: 5px;

$box-shadow-hover: 0 8px 4px -4px rgba(54, 64, 63, 0.1);

.al-badge {
  background-color: $bg-content;
  border-radius: $br-radius;
  color: $font-color;
  font-size: $font-size;
  font-weight: normal;
  margin-bottom: $m-content;
  margin-right: $m-content * 2;
  margin-top: $m-content;
  padding: $pd-body;
}

.al-badge:not(.not-clickable) {
  cursor: pointer;

  &:hover {
    background-color: $bg-content-hover;
    box-shadow: $box-shadow-hover;
    color: $font-color-hover;
  }

  &:active {
    background-color: $bg-content-active;
    color: $font-color-active;
  }
}
</style>
